export default {
  namespaced: true,
  state: {
    refs: {},
  },
  mutations: {
    addRef(state, { refId, refValue }) {
      state.refs[refId] = refValue;
    },
    clearRefs(state) {
      state.refs = {};
    },
  },
  actions: {
    addRef({ commit }, payload) {
      commit('addRef', payload);
    },
    addRefs({ commit }, { refs }) {
      refs.forEach((ref) => {
        commit('addRef', ref);
      });
    },
    clearRefs({ commit }) {
      commit('clearRefs');
    },
  },
};
